export const SORT_ENUM = {
  CONTRAST_DIFF:'Contrast Diff',
  TOTAL:'Total',
  ABS_DIFF:'Absolute Diff',
  DIFF:'Cohort Diff',
  ALPHA:'Alphabetical',
}

export const SORT_ORDER_ENUM = {
  ASC:'asc',
  DESC:'desc',
}

export const SORT_VIEW_BY = {
  SIMILAR: 'Similar',
  DIFFERENT: 'Differential',
  // ALPHA: 'Alphabetic',
}
